<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-card class="account-member-form-card">
        <b-form @submit.prevent>
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="UserIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.basicInfo') }}
                  </h5>
                </div>

                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.username')"
                      label-for="mc-username"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('accountMembers.fields.username')"
                        rules="required"
                      >
                        <b-form-input
                          id="mc-username"
                          v-model="form.username"
                          :placeholder="$t('accountMembers.placeholders.username')"
                          disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.nickname')"
                      label-for="mc-nickname"
                    >
                      <b-form-input
                        id="mc-nickname"
                        v-model="form.nickName"
                        :placeholder="$t('accountMembers.placeholders.nickname')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.password')"
                      label-for="change-password"
                      class="mb-0"
                    >
                      <b-button
                        v-ripple.400="'var(--hdg-ripple-primary)'"
                        type="button"
                        variant="outline-primary"
                        block
                        @click.prevent="modalPassword = true"
                      >
                        <feather-icon
                          icon="LockIcon"
                          size="14"
                          class="mr-50"
                        />
                        {{ $t('Change Password') }}
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="CreditCardIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.credit') }}
                  </h5>
                </div>

                <b-form-group
                  :label="$t('accountMembers.fields.credit')"
                  label-for="credit"
                  class="mb-0"
                >
                  <b-form-input
                    id="credit"
                    v-model="form.balance"
                    disabled
                  />
                </b-form-group>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="ToggleRightIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('Status') }}
                  </h5>
                </div>

                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('Suspend')"
                      label-for="suspend-status"
                      class="mb-md-0"
                    >
                      <b-form-input
                        id="suspend-status"
                        disabled
                        :value="isEnable === true ? $t('No') : $t('Yes')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-end"
                  >
                    <b-button
                      v-ripple.400="'var(--hdg-ripple-primary)'"
                      type="button"
                      variant="outline-primary"
                      block
                      @click.prevent="submitStatus"
                    >
                      <feather-icon
                        icon="RefreshCwIcon"
                        size="14"
                        class="mr-50"
                      />
                      {{ $t('Edit Status') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                size="lg"
                class="d-inline-flex align-items-center"
                @click.prevent="onSubmitForm"
              >
                <feather-icon
                  icon="SaveIcon"
                  size="18"
                  class="mr-50"
                />
                {{ $t('accountMembers.actions.submit') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>

      <b-modal
        v-model="modalPassword"
        cancel-variant="secondary"
        ok-only
        :ok-title="$t('Submit')"
        centered
        :title="$t('เปลี่ยนรหัสผ่าน')"
        button-size="sm"
        @ok="submitPassword"
      >
        <b-form @submit.prevent>
          <b-form-group
            :label="$t('Password')"
            label-for="mc-password"
          >
            <validation-provider
              #default="{ errors }"
              name="Password"
              vid="Password"
              rules="required|min:8|password"
            >
              <b-form-input
                id="mc-password"
                v-model="passwordForm.password"
                autofocus
                :placeholder="$t('Password')"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            :label="$t('Confirm Password')"
            label-for="mc-confirm-password"
          >
            <validation-provider
              #default="{ errors }"
              name="Confirm Password"
              rules="required|confirmed:Password"
            >
              <b-form-input
                id="mc-confirm-password"
                v-model="passwordForm.passwordConfirm"
                :state="errors.length > 0 ? false:null"
                :placeholder="$t('Confirm Password')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-form>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import customerService from '@/service/customerService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        username: '',
        nickName: '',
      },
      isEnable: false,

      modalPassword: false,
      passwordForm: {
        password: '',
        passwordConfirm: '',
      },
    }
  },
  async mounted() {
    const username = this.$router.currentRoute.query.id
    if (username !== null && username !== undefined) {
      const res = await customerService.getAuthen(`find?username=${username}`)
      if (res.status === 200) {
        this.form = res.data
        this.isEnable = res.data.isEnable
      }
    }
  },
  methods: {
    onSubmitForm() {
      this.$refs.simpleRules.validate()
        .then(async success => {
          if (success) {
            this.$swal({
              dark: true,
              title: 'Are you sure?',
              text: 'คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            })
              .then(async result => {
                if (result.value) {
                  const formSender = { ...this.form }
                  const res = await customerService.putAuthen(`?username=${this.form.username}`, formSender)
                  if (res.status === 200) {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'success',
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: res.data,
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'Error',
                        icon: 'AlertCircleIcon',
                        variant: 'danger',
                        text: res.data,
                      },
                    })
                  }
                }
              })
          }
        })
    },
    submitStatus() {
      this.$refs.simpleRules.validate()
        .then(async success => {
          if (success) {
            this.$swal({
              dark: true,
              title: 'Lock / Unlock Account',
              text: 'คุณเเน่ใจว่าต้องการดำเนินการใช่หรือไม่ ?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            })
              .then(async result => {
                if (result.value) {
                  const res = await customerService.putAuthen(`toggle-status?username=${this.form.username}`)
                  if (res.status === 200) {
                    this.isEnable = res.data
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'success',
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: 'ดำเนินการสำเร็จ',
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'Error',
                        icon: 'AlertCircleIcon',
                        variant: 'danger',
                        text: res.data,
                      },
                    })
                  }
                }
              })
          }
        })
    },
    submitPassword(e) {
      e.preventDefault()
      this.$refs.simpleRules.validate()
        .then(async success => {
          if (success) {
            this.$swal({
              dark: true,
              title: 'Are you sure?',
              text: 'คุณเเน่ใจว่าต้องการเปลี่ยนรหัสผ่านใช่หรือไม่',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            })
              .then(async result => {
                if (result.value) {
                  const formSender = { ...this.passwordForm }
                  delete formSender.passwordConfirm

                  const res = await customerService.putAuthen(`password?username=${this.form.username}`, formSender)
                  if (res.status === 200) {
                    this.modalPassword = false
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'success',
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: res.data,
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'Error',
                        icon: 'AlertCircleIcon',
                        variant: 'danger',
                        text: res.data,
                      },
                    })
                  }
                }
              })
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';

.account-member-form-card {
  width: 50%;
}

@media (max-width: 991.98px) {
  .account-member-form-card {
    width: 100%;
  }
}
</style>
